/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useIntl } from 'react-intl';

import { cssMap, jsx } from '@atlaskit/css';
import StarIcon from '@atlaskit/icon/core/star-unstarred';
import { Box } from '@atlaskit/primitives/compiled';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';

import { messages } from './messages';
import { formatNumber } from './utils';

const styles = cssMap({
	count: {
		font: token('font.body.small'),
		display: 'flex',
		alignItems: 'center',
		gap: token('space.050'),
		paddingInlineStart: token('space.025'),
	},
});

export const AgentStarCount = ({
	starCount,
	isLoading,
}: {
	starCount: number | null | undefined;
	isLoading: boolean;
}): JSX.Element | null => {
	const { formatMessage } = useIntl();

	if ((starCount === null || starCount === undefined) && !isLoading) {
		return null;
	}

	return (
		<Box xcss={styles.count}>
			<StarIcon color="currentColor" label="" size="small" />
			{isLoading ? (
				<Skeleton
					testId="agent-profile-info-star-count-skeleton"
					isShimmering
					height={16}
					width={75}
				/>
			) : (
				formatMessage(messages.starredCount, { starCount: formatNumber(starCount ?? 0) })
			)}
		</Box>
	);
};
